module.exports = __webpack_public_path__ + "static/Pollinator_s Menu detail 2-1c24fa446b210932c7e5be24b3f1c2fd.jpg";